import React from 'react';

function FAB({ actions = [], position = 'bottom-right', gap = 12 }) {
    const posClass = position === 'bottom-right' ? 'bottom-20 right-5' : position === 'bottom-left' ? 'bottom-20 left-5' : position;
    return (
        <div className={`fixed ${posClass} z-40`}>
            <div className="flex flex-col items-end" style={{ gap }}>
                {actions.map((action, idx) => (
                    <button
                        key={idx}
                        onClick={action.onClick}
                        className={`w-12 h-12 rounded-full shadow-lg border flex items-center justify-center transition-colors ${action.className || ''}`}
                        style={{ background: action.bg || '#ffffff', color: action.color || '#0f172a', borderColor: action.borderColor || '#e5e7eb' }}
                        aria-label={action.label}
                        title={action.title || action.label}
                    >
                        {action.icon || action.text || '•'}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default FAB;
